import { Button } from '@/components/common/button'
import { Note } from '@/components/common/note'
import { InfoIcon } from '@/components/icons/info'

const FALLBACK_ETHERFI_URL = 'https://ether.fi'

interface Props {
  protocolVaultUrl?: string
}

export const EtherfiWithdrawNote = ({ protocolVaultUrl }: Props) => {
  return (
    <Note>
      <div className="flex items-center gap-2">
        <InfoIcon />
        <h6 className="font-bold">Redemption note</h6>
      </div>
      <p className="text-xs">
        Redemptions from this vault are not instant and processed by the vault curator. To learn more, visit the{' '}
        <Button variant="default" size="default" className="rounded-full text-xs underline" asChild>
          <a href={protocolVaultUrl ?? FALLBACK_ETHERFI_URL} target="_blank" rel="noreferrer">
            Ether.fi app
          </a>
        </Button>
        .
      </p>
    </Note>
  )
}
